'use client';

import { useMemo } from 'react';

import { highlighterApi } from '@highlight-cp/highlighter-api';

import { useGetCurrentProjectId } from '../use-get-current-project-id';

const useGetAdminOptInSurveys = () => {
  const projectId = useGetCurrentProjectId();
  const {
    data: allSurveys,
    isLoading,
    error,
  } = highlighterApi.useGetAdminProjectsByIdSurveysQuery(
    { id: projectId ?? 0 },
    { skip: !projectId },
  );
  const data = useMemo(() => {
    return allSurveys?.filter((survey) => survey.type === 'optInSurvey');
  }, [allSurveys]);

  return {
    data,
    isLoading,
    error,
  };
};

export default useGetAdminOptInSurveys;
